/** Visible keyboard focus without an outline or ring. */
export const focusSurface =
  'focus-visible:outline-none focus-visible:border-primary-600 focus-visible:bg-primary-50 focus-visible:text-primary-900';

/** Same treatment for the visible disc inside a focused button. */
export const groupFocusSurface =
  'group-focus-visible:border-primary-600 group-focus-visible:bg-primary-50 group-focus-visible:text-primary-900';
